import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { EcmPartsService } from '../ecm-parts.service';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { TprecmApiService } from 'src/modules/api';
import { EcmService } from '../../../ecm.service';
import { map } from 'rxjs/operators';


@Component({
  selector: 'ecm-parts-add-tool-relation',
  templateUrl: './ecm-parts-add-tool-relation.component.html',
})
export class EcmPartsAddToolRelationComponent implements OnInit {
  tools: any[];
  partId: number;
  relations: any[];

  addToolRelationForm = new UntypedFormGroup({
    tool: new UntypedFormControl(null, [Validators.required])
  });

  constructor(private readonly dialogRef: MatDialogRef<EcmPartsAddToolRelationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly tprecmApiService: TprecmApiService,
    private readonly ecmService: EcmService,
    private readonly ecmPartsService: EcmPartsService,
    private readonly toastr: ToastrService
  ) { }

  ngOnInit() {
    this.partId = this.data.partId;
    this.relations = this.data.relations;

    this.ecmService.getEcmTool(this.partId)
      .pipe(map(tools => tools.filter(tool => !this.relations.includes(tool.id))))
      .subscribe((val) => {
        this.tools = val;
      });
  }

  save() {
    if (!this.addToolRelationForm.valid ) {
      this.toastr.error('Please select a tool to relate to the part.');
      return;
    }


    const tool = this.addToolRelationForm.get('tool');

    this.ecmPartsService.createToolPartRelation(tool.value.id, this.partId)
      .subscribe(
          () => {
              this.toastr.success('Tool was successfully assigned to part!');
              this.dialogRef.close();
          }
      );
  }

  close() {
    this.dialogRef.close();
  }

}
